// import { DateUtil } from "../common/date";

export class BusinessContact {

    public BCID: number = 0;
    public Active: boolean = true;
    public FirstName: string = '';
    public LastName: string = '';
    public MiddleName: string = '';
    public Phone: string = '';
    public PhoneCountryCode: string = '';
    public SecondaryPhoneCountryCode: string = '';
    public Email: string = '';
    public Name: string = '';
    public SecondaryPhone: string = '';
    public errorMessages: Array<string> = new Array<string>();
    public IntialFirstLastName: string = ''; 


    constructor(businessContact: BusinessContact) {
        this.BCID = businessContact.BCID || 0;
        this.Active = businessContact.Active || false;
        this.FirstName = businessContact.FirstName || '';
        this.LastName = businessContact.LastName || '';
        this.MiddleName = businessContact.MiddleName || '';
        this.Phone = businessContact.Phone || '';
        this.PhoneCountryCode = businessContact.PhoneCountryCode || '';
        this.SecondaryPhoneCountryCode = businessContact.SecondaryPhoneCountryCode || '';
        this.SecondaryPhone = businessContact.SecondaryPhone || '';
        this.Email = businessContact.Email || '';
        this.Name = this.LastName + ', ' + this.FirstName;       
        this.IntialFirstLastName = this.FirstName.substring(0, 1) + this.LastName.substring(0, 1);
    }
}